import { render, staticRenderFns } from "./EditAttr.vue?vue&type=template&id=839a865a&scoped=true&"
import script from "./EditAttr.vue?vue&type=script&lang=js&"
export * from "./EditAttr.vue?vue&type=script&lang=js&"
import style0 from "./EditAttr.vue?vue&type=style&index=0&id=839a865a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839a865a",
  null
  
)

export default component.exports